module.exports = __webpack_public_path__ + "img/95.00e2d9ee.jpg";